import * as React from "react";

function RectangleAdIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M301.5 317.3c5.9 11.8 1.1 26.2-10.8 32.2-11.8 5.9-26.2 1.1-32.2-10.8l-5.3-10.7h-90.4l-5.3 10.7c-6 11.9-20.4 16.7-32.2 10.8-11.9-6-16.7-20.4-10.8-32.2l72-144c4.1-8.2 12.4-13.3 20.6-13.3 10 0 18.3 5.1 22.4 13.3l72 144zM186.8 280h42.4L208 237.7 186.8 280zM416 184c0-13.3 10.7-24 24-24s24 10.7 24 24v144c0 13.3-10.7 24-24 24-6.6 0-12.6-2.7-17-7.9-9.4 5.4-19.9 7.9-31 7.9-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1V184zm-24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM0 96c0-35.35 28.65-64 64-64h448c35.3 0 64 28.65 64 64v320c0 35.3-28.7 64-64 64H64c-35.35 0-64-28.7-64-64V96zm48 0v320c0 8.8 7.16 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.84-7.2-16-16-16H64c-8.84 0-16 7.16-16 16z"
  }));
}

const ForwardRef = React.forwardRef(RectangleAdIcon);
export default ForwardRef;